
/*
window.addEventListener("dx_init", function(event){  
    dx_backgroundimages_init();

    // display first background image
    setTimeout(function(){
        var backgroundImages = document.getElementsByClassName("wp-block-dx-background-image");
        if(backgroundImages[0]!=undefined){            
            backgroundImages[0].dispatchEvent(new Event("click"));
        }
   }, 1);
});
*/
//var win = window;
if(window.parent==window){
    window.addEventListener("load", function(){
       dx_backgroundimages_init();

        setTimeout(function(){
            console.log("show first bg image")
            var backgroundImages = document.getElementsByClassName("wp-block-dx-background-image");
            if(backgroundImages[0]!=undefined){            
                backgroundImages[0].dispatchEvent(new Event("click"));
            }
        }, 1); 
    });   
    
}  
let dx_backgroundImages_first = false;
window.addEventListener("dx_backgroundimage_init", function(event){ 
    //win = window.frames[0]; // is editor
    dx_backgroundimage_init(event.detail.block);
    if(!dx_backgroundImages_first){
        dx_backgroundImages_first = true;
        setTimeout(function(){
            console.log("foo");
            event.detail.block.dispatchEvent(new Event("click"));
        }, 1);    
        
    }
});


 window.addEventListener("load", function(){ 
   

    // display first background image
   
});
/*
window.addEventListener("dx_backgroundimage_init", function(event){ 
    dx_backgroundimage_init(event.detail.block);
});  
*/
function dx_backgroundimages_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-background-image"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_backgroundimage_init(blocks[i]);               
    }   
}    

function dx_backgroundimage_init(block){
    //console.log("init single");
   
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");
    
    block.onclick=function(event){
        let url=event.currentTarget.getAttribute("data-url");
        let posX=event.currentTarget.getAttribute("data-x");
        let posY=event.currentTarget.getAttribute("data-y");
        dx_setBackgroundImage(url, posX, posY);
    }  
}





/*
function dx_navigations_update(){
    var blocks = document.getElementsByClassName("wp-block-dx-navigation"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_navigation_update(blocks[i]);               
    }  
}   

function dx_navigation_update(block){
    
}
*/
  
